module.exports = __webpack_public_path__ + "img/COMBO WAVES RED.46aa8f4.svg";